import "./Contact.css";
import { AWS_CONFIG } from "../config/aws";
import ContactForm from "./../components/ContactForm";
import InstagramIcon from "./../assets/icons/instagram.png";
import LinkedinIcon from "./../assets/icons/linkedin.png";

function Contact() {
  const contactBanner = `${AWS_CONFIG.CDN_URL}/static/contact/contact.webp`;

  return (
    <div className="contact-main-div">
      <div className="contact-banner-div">
        <img src={contactBanner} alt="Photographie d'illustration" className="contact-banner-img" />
        <h3 className="contact-banner-title">Contactez-moi</h3>
      </div>
      <div className="contact-form-div">
        <h3 className="contact-form-title">Ecrivez-moi</h3>
        <ContactForm></ContactForm>
      </div>
      <hr className="contact-footer-top-hr" />
      <div className="contact-footer-div">
        <div className="contact-footer-middle">
          <h4>Contact</h4>
          <adress>
            <a href="mailto:sansetiquette@outlook.fr">sansetiquette@outlook.fr</a>
            <a href="tel:+33671948864">+33 6 71 94 88 64</a>
          </adress>
        </div>
        <div className="contact-footer-right">
          <h4>Reseaux</h4>
          <div className="reseaux-icons">
            <a href="https://www.instagram.com/sans_etiquette" target="_blank" rel="noopener noreferrer">
              <img src={InstagramIcon} alt="icône Instagram" className="instagram-img" />
            </a>
            <a href="https://www.linkedin.com/in/sa-mmc6" target="_blank" rel="noopener noreferrer">
              <img src={LinkedinIcon} alt="icône Linkedin" className="linkedin-img" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
